import { createStore } from '@updater-core/lib/store';

export const createInteractor = ({ initialState }) => {
  const store = createStore(initialState);

  return {
    getState: store.getState,
    connect: (fn) => {
      fn(store.getState());
      return store.subscribe((state) => fn(state));
    },
    subscribe: store.subscribe,
    destroy: () => {},
    selectors: {},
    actions: {},
  };
};
